import { Divider, Grid, Typography, makeStyles } from '@material-ui/core';
import i18n from 'i18n';
import { ClientUsers } from 'modules/clients/interfaces';
import moment from 'moment';
import React from 'react';
import styles from './styles';

const useStyles = makeStyles(styles);

export interface AuditSessionProps {
  values: ClientUsers | undefined;
}

const AuditSession = ({ values }: AuditSessionProps) => {
  const classes = useStyles();

  const dateFormat = (date: string) =>
    moment(new Date(date))
      .local()
      .format(
        i18n.language === 'en-US'
          ? `MM/DD/YYYY [${i18n.t('AUDIT_SESSION.TIME_AT_KEY')}] hh:mm`
          : `DD/MM/YYYY [${i18n.t('AUDIT_SESSION.TIME_AT_KEY')}] HH:mm`
      );

  return (
    <>
      <Grid item xs={12} data-testid={'autosky-auditsession'}>
        <Typography variant="h5" component="div">
          {i18n.t('AUDIT_SESSION.AUDIT_KEY')}
        </Typography>
        <Divider />
        <Grid item xs={12} className={classes.updatedByInfo}>
          {values?.user_agent_info.browser_family &&
            values?.user_agent_info.os_family && (
              <Grid container xs={4} justify="space-between">
                <Typography>
                  {`${i18n.t('AUDIT_SESSION.OS_KEY')}: ${
                    values?.user_agent_info.os_family
                  }`}
                </Typography>
                <Typography>
                  {`${i18n.t('AUDIT_SESSION.BROWSER_KEY')}: ${
                    values?.user_agent_info.browser_family
                  }`}
                </Typography>
              </Grid>
            )}

          {values?.created_by_operator && (
            <Typography>
              {`${i18n.t('CREATED_BY_KEY')} ${
                values?.created_by_operator.first_name
              } ${values?.created_by_operator.last_name} (${
                values?.created_by_operator.email
              }) ${i18n.t('AUDIT_SESSION.ON_KEY')} ${dateFormat(
                values?.created_at
              )}`}
            </Typography>
          )}

          {values?.updated_by_operator && (
            <Typography>
              {`${i18n.t('AUDIT_SESSION.UPDATED_BY_KEY')} ${
                values?.updated_by_operator.first_name
              } ${values?.updated_by_operator.last_name} (${
                values?.updated_by_operator.email
              }) ${i18n.t('AUDIT_SESSION.ON_KEY')} ${dateFormat(
                values?.updated_at
              )}`}
            </Typography>
          )}
        </Grid>
      </Grid>
    </>
  );
};

export default AuditSession;
